import React, {ChangeEvent, FC, SVGProps, useCallback} from "react";
import {TextInput} from "flowbite-react";
import {useDebounce} from "../../hooks/use-debounce";
import {IconMagnifierSmall} from "../../icons";

export interface SearchInputProps {
    id?: string,
    onChange?: (value: string) => void,
    debounceTime?: number
    startIcon?: FC<SVGProps<SVGSVGElement>>,
    endIcon?: FC<SVGProps<SVGSVGElement>>,
    placeholder?: string,
    error?: boolean,
    required?: boolean
}

export const SearchInput: React.FC<SearchInputProps> = (props) => {
    const debouncedOnChange = useDebounce((value: string) => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, props.debounceTime ?? 0);
    const handleOnChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        debouncedOnChange(event.target.value);
    }, [props.onChange, debouncedOnChange]);

    return (<TextInput
        id={props.id}
        type={'search'}
        icon={props.startIcon}
        rightIcon={props.endIcon ?? IconMagnifierSmall}
        onChange={handleOnChange}
        placeholder={props.placeholder}
        required={props.required}
        color={props.error ? 'failure' : 'gray'}/>);
}
